/* eslint camelcase: 0, no-use-before-define: 0 */

import $ from 'jquery'

const defaults = {
  topId: 'top_scroll_page',
  bottomId: 'bottom_scroll_page',
  delay: 0,
  height: 20
}
const options = $.extend(defaults, options)
let both_el = null

class DNDUtil {
  initEvents () {
    let top_el = $('#' + options.topId)
    if (!top_el.length) {
      top_el = $('<div id="top_scroll_page">&nbsp;</div>').appendTo(
        '.pagecontent'
      )
    }

    let bottom_el = $('#' + options.bottomId)
    if (!bottom_el.length) {
      bottom_el = $('<div id="bottom_scroll_page">&nbsp;</div>').appendTo(
        '.pagecontent'
      )
    }

    both_el = $('#top_scroll_page, #bottom_scroll_page')
    both_el.hide()
    both_el.css({
      position: 'fixed',
      left: 0,
      right: 0,
      height: options.height,
      zIndex: 999999
    })

    top_el.css({ top: 0 })
    bottom_el.css({ bottom: 0 })

    var lastTop
    var lastBottom

    both_el.on('dragenter', function () {
      return true
    })

    both_el.on('dragover', function () {
      // Wait a little while before doing stuff here again
      if ($('html,body').is(':animated')) return true

      var scrollTop = $('.pagecontent').scrollTop()
      var direction = $(this).attr('id') === options.topId ? -1 : 1
      var last = direction === -1 ? lastTop : lastBottom
      var pageHeight =
        $('.page-header').outerHeight() + $('.page-inner').outerHeight()
      var current =
        direction === -1
          ? scrollTop
          : pageHeight - (scrollTop + $(window).height())

      if (last !== undefined && last === current && current > 0) {
        var newScrollTop = scrollTop + direction * 50
        $('.pagecontent').animate(
          { scrollTop: newScrollTop },
          options.delay,
          'linear'
        )
      }

      if (direction === -1) lastTop = current
      else lastBottom = current
      return true
    })

    $(document).on('dragstart', this._onDragStart)
    $(document).on('dragend', this._onHide)
    both_el.on('mouseover', this._onHide)
  }

  releaseEvents () {
    $(document).off('dragstart', this._onDragStart)
    $(document).off('dragend', this._onHide)
    both_el.remove()
  }

  /* Private functions */
  _onDragStart () {
    both_el.show()
    return true
  }

  _onHide () {
    both_el.hide()
    return true
  }
}

export default new DNDUtil()
